import {
  postChat,
  updateChat,
  toggleWidget,
  gptKeyExists,
  clearChatbot,
  minimizeWidget,
  setTempHistory,
  setHistoryObject,
  setSettings,
  closePrebuiltPromptOptions,
} from '../routines/velarisAiRoutines';

import { logOut } from '../routines';

const initialState = {
  type: 'CHAT',
  chatHistory: [],
  assistantResponse: null,
  responseReceived: true,
  toggleVelarisAi: true,
  isWidgetOpen: false,
  isGptKeyPresent: false,
  error: null,
  isMinimized: false,
  tempHistory: [],
  historyObject: {
    initialInput: false,
    initialUserInput: '',
    userMessage: '',
  },
  lastPayload: {},
  settings: {
    selectedTone: '',
    selectedPersonalities: [],
    openSettings: false,
    extraChanges: {},
  },
  prebuiltPrompts: {
    showPrebuiltPromptOptions: true,
    prompt: '',
    additionalInfo: '',
    renewalDate: '',
    fromAssignee: '',
    toAssignee: null,
    toAssigneeId: null,
    promptUsed: false,
  },
};

const velarisAiReducer = (state = initialState, action) => {
  switch (action.type) {
    case postChat.TRIGGER: {
      return {
        ...state,
        responseReceived: false,
        error: null,
      };
    }
    case postChat.SUCCESS: {
      let chatMessages = [];
      const { assistantResponse, lastPayload } = action.payload;
      const { messages, extractedContents, settings } = assistantResponse;
      if (
        settings.type === 'SUMMARIZE' ||
        settings.type === 'PREBUILT_PROMPTS'
      ) {
        const lastMessageIndex = messages.length - 1;
        if (messages[lastMessageIndex].role === 'user') {
          chatMessages = messages.slice(0, -1);
        } else {
          chatMessages = [...messages];
        }
        chatMessages.push({
          role: 'assistant',
          content: `${extractedContents}`,
        });
      } else {
        chatMessages = [
          ...messages,
          {
            role: 'assistant',
            content: extractedContents,
          },
        ];
      }
      return {
        ...state,
        error: null,
        chatHistory: chatMessages,
        assistantResponse: extractedContents,
        responseReceived: true,
        showPrebuiltPromptOptions: false,
        lastPayload,
      };
    }
    case postChat.FAILURE: {
      return {
        ...state,
        responseReceived: true,
        error: action.payload.error,
        chatHistory: [...action.payload.messages],
        lastPayload: action.payload.lastPayload,
      };
    }
    case logOut.SUCCESS:
      return {
        ...initialState,
      };
    case updateChat.TRIGGER: {
      const appendToChatHistory = {
        role: 'assistant',
        content: `${action.payload.tempMessage}`,
      };
      const filteredMessages = action.payload.messages.filter(
        (obj) => obj.toDelete === true
      );
      return {
        ...state,
        error: null,
        chatHistory: [...filteredMessages, appendToChatHistory],
        assistantResponse: action.payload.tempMessage,
      };
    }
    case toggleWidget.TRIGGER: {
      return {
        ...state,
        toggleVelarisAi: true,
        isWidgetOpen: action.payload,
        error: action.payload?.error || null,
      };
    }
    case toggleWidget.SUCCESS: {
      return {
        ...state,
        toggleVelarisAi: action.payload,
        error: null,
      };
    }
    case toggleWidget.FAILURE: {
      return {
        ...state,
        toggleVelarisAi: true,
        error: action.payload.error,
      };
    }
    case gptKeyExists.TRIGGER: {
      return {
        ...state,
        isGptKeyPresent: false,
        error: null,
      };
    }
    case gptKeyExists.SUCCESS: {
      return {
        ...state,
        isGptKeyPresent: action.payload.isGptKeyPresent,
        error: null,
      };
    }
    case gptKeyExists.FAILURE: {
      return {
        ...state,
        isGptKeyPresent: false,
        error: action.payload.error,
      };
    }
    case clearChatbot.TRIGGER: {
      return {
        ...initialState,
        isGptKeyPresent: true,
        isWidgetOpen: true,
        toggleVelarisAi: true,
        showPrebuiltPromptOptions: true,
      };
    }
    case minimizeWidget.TRIGGER: {
      return {
        ...state,
        isMinimized: false,
        error: null,
      };
    }
    case minimizeWidget.SUCCESS: {
      return {
        ...state,
        isMinimized: action.payload,
        error: null,
      };
    }
    case minimizeWidget.FAILURE: {
      return {
        ...state,
        isMinimized: false,
        error: action.payload.error,
      };
    }
    case setTempHistory.TRIGGER: {
      return {
        ...state,
        tempHistory: [],
        error: action.payload?.error || null,
      };
    }
    case setTempHistory.SUCCESS: {
      return {
        ...state,
        tempHistory: action.payload,
        error: null,
      };
    }
    case setTempHistory.FAILURE: {
      return {
        ...state,
        tempHistory: [],
        error: action.payload.error,
      };
    }
    case setHistoryObject.TRIGGER: {
      return {
        ...state,
        historyObject: {
          initialInput: false,
          initialUserInput: '',
          userMessage: '',
        },
        error: action.payload?.error || null,
      };
    }
    case setHistoryObject.SUCCESS: {
      return {
        ...state,
        historyObject: {
          ...state.historyObject,
          initialInput: action.payload.initialInput,
          initialUserInput: action.payload.initialUserInput,
          userMessage: action.payload.userMessage,
        },
        error: null,
      };
    }
    case setHistoryObject.FAILURE: {
      return {
        ...state,
        historyObject: {
          initialInput: false,
          initialUserInput: '',
          userMessage: '',
        },
        error: action.payload.error,
      };
    }
    case setSettings.TRIGGER: {
      return {
        ...state,
        settings: {
          selectedTone: '',
          selectedPersonalities: [],
          openSettings: false,
          extraChanges: {},
        },
        error: action.payload?.error || null,
      };
    }
    case setSettings.SUCCESS: {
      return {
        ...state,
        settings: {
          ...state.settings,
          selectedTone: action.payload.selectedTone,
          selectedPersonalities: action.payload.selectedPersonalities,
          openSettings: action.payload.openSettings,
          extraChanges: action.payload.extraChanges,
        },
        error: null,
      };
    }
    case setSettings.FAILURE: {
      return {
        ...state,
        settings: {
          selectedTone: '',
          selectedPersonalities: [],
          openSettings: false,
          extraChanges: {},
        },
        error: action.payload.error,
      };
    }
    case closePrebuiltPromptOptions.TRIGGER: {
      return {
        ...state,
        prebuiltPrompts: {
          showPrebuiltPromptOptions: true,
          prompt: '',
          additionalInfo: '',
          renewalPeriod: 'Monthly',
        },
        error: null,
      };
    }
    case closePrebuiltPromptOptions.SUCCESS: {
      return {
        ...state,
        prebuiltPrompts: {
          showPrebuiltPromptOptions: action.payload.showPrebuiltPromptOptions,
          prompt: action.payload.prompt,
          additionalInfo: action.payload.additionalInfo,
          renewalDate: action.payload.renewalDate,
          fromAssignee: action.payload.fromAssignee,
          toAssignee: action.payload.toAssignee,
          toAssigneeId: action.payload.toAssigneeId,
          renewalPeriod: action.payload.renewalPeriod,
          promptUsed: action.payload.promptUsed,
        },
        error: null,
      };
    }
    case closePrebuiltPromptOptions.FAILURE: {
      return {
        ...state,
        prebuiltPrompts: {
          showPrebuiltPromptOptions: true,
          prompt: '',
          additionalInfo: '',
          renewalPeriod: 'Monthly',
        },
        error: action.payload.error,
      };
    }
    default:
      return state;
  }
};

export default velarisAiReducer;
